'use client';

import { useState, useEffect, Suspense } from 'react';
import dynamic from 'next/dynamic';

const ServicesSection = dynamic(() => import('@/components/ServicesSection').catch(() => ({ default: () => null })));

const SectionSkeleton = ({ height = 'min-h-[500px]' }: { height?: string }) => (
  <div className={height} aria-hidden="true" />
);

export default function ServicesWrapper() {
  const [isFlipped, setIsFlipped] = useState(false);

  useEffect(() => {
    const handleFlipChange = (event: CustomEvent) => {
      setIsFlipped(event.detail.isFlipped);
    };

    window.addEventListener('rasiphal-flip', handleFlipChange as EventListener);

    return () => {
      window.removeEventListener('rasiphal-flip', handleFlipChange as EventListener);
    };
  }, []);

  return (
    <div>
      <div 
        className={`mt-0 sm:mt-0 md:mt-0 lg:mt-0 transition-all duration-500 ease-in-out ${
          isFlipped ? 'lg:mt-2' : 'lg:mt-0'
        }`}
        id="services-wrapper"
        style={{ display: 'block', visibility: 'visible' }}
      >
        <Suspense fallback={<SectionSkeleton height="min-h-[500px]" />}>
          <ServicesSection simplified={true} />
        </Suspense>
      </div>
    </div>
  );
}

